import Swiper from 'swiper';
import { AlpineComponent } from 'alpinejs';
import { Navigation, Controller, EffectFade, Thumbs } from 'swiper/modules';

export default (): AlpineComponent => ({
    
    init(): void {

        const that = this;
        const textSwiperElement = this.$el.getElementsByClassName('cmp-feature-wheel__text-swiper');
        const imageSwiperElement = this.$el.getElementsByClassName('cmp-feature-wheel__image-swiper');
        const iconSwiperElement = this.$el.getElementsByClassName('cmp-feature-wheel__icon-swiper');
        const iconSwiper = new Swiper(iconSwiperElement[0], {
            //modules: [Controller, Thumbs],
            ////slideToClickedSlide: true,
            //slidesPerView: 10,
            //effect: null,
            //loop: true,
            //loopedSlides: 10, 
            //enabled: true,
            
            centerInsufficientSlides: true,
            //centeredSlides: true,
            //controller: {
            //    by: 'slide',
            //},
            // on: {
            //     //progress: that.swiperWheelEffect.onProgress,
            //    // setTransition: that.swiperWheelEffect.onSetTransition,
            // },
            spaceBetween: 20,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,

        });
        const imageSwiper = new Swiper(imageSwiperElement[0], {
            modules: [EffectFade, Thumbs],
            slidesPerView: 1,
            effect: 'fade',
            enabled: true,
            //thumbs: {
            //    swiper: iconSwiper,
            //},
            /*freeMode: true,
            watchSlidesProgress: true,*/

        });
        const textSwiper = new Swiper(textSwiperElement[0], {
            modules: [Navigation, Controller, Thumbs],
            slidesPerView: 1,
            spaceBetween: 32,
            controller: {
                by: 'slide',
                control: [imageSwiper],
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: iconSwiper,
            },
        });
        textSwiper.on('slideChangeTransitionStart', function() {
            console.log('slide changed');
        });
        //iconSwiper.controller.control = [imageSwiper, textSwiper];
    },
});